// assets/min-order.js
document.addEventListener("DOMContentLoaded", () => {
  const MIN_ORDER = 449; // ₹449 minimum order
  const CHECK_INTERVAL = 200; // faster refresh rate

  let lastTotal = 0;
  let checking = false;

  const selectors = {
    subtotal: "[data-cart-subtotal], .cart-subtotal__price, .totals__subtotal-value, .cart__subtotal",
    checkoutBtn: "[name='checkout'], button[name='checkout'], .cart__checkout, .cart__submit",
    cartForms: "form[action*='/cart']",
    notice: "#min-order-notice",
  };

  // Inject or find existing notice
  function ensureNotice() {
    let notice = document.querySelector(selectors.notice);
    if (!notice) {
      notice = document.createElement("div");
      notice.id = "min-order-notice";
      notice.style.cssText =
        "color:red;font-size:20px;margin-top:10px;font-weight:600;";
      const target = document.querySelector(selectors.cartForms);
      if (target) target.parentNode.insertBefore(notice, target);
    }
    return notice;
  }

  function getCartSubtotal() {
    const el = document.querySelector(selectors.subtotal);
    if (!el) return 0;
    const text = el.textContent.replace(/[^\d.]/g, "");
    return parseFloat(text || "0");
  }

  async function fetchCartSubtotal() {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();
      return cart.total_price / 100;
    } catch {
      return getCartSubtotal();
    }
  }

  async function checkCart() {
    if (checking) return;
    checking = true;

    const subtotal = await fetchCartSubtotal();
    const checkoutBtns = document.querySelectorAll(selectors.checkoutBtn);
    const notice = ensureNotice();

    if (subtotal < MIN_ORDER) {
      notice.textContent = `Your order total is ₹${subtotal.toFixed(
        2
      )}. You must have an order of at least ₹${MIN_ORDER}.`;
      checkoutBtns.forEach((btn) => {
        btn.disabled = true;
        btn.style.opacity = "0.5";
        btn.style.cursor = "not-allowed";
      });
    } else {
      notice.textContent = "";
      checkoutBtns.forEach((btn) => {
        btn.disabled = false;
        btn.style.opacity = "1";
        btn.style.cursor = "pointer";
      });
    }

    lastTotal = subtotal;
    checking = false;
  }

  // Observe quantity or subtotal changes
  const observer = new MutationObserver(() => {
    clearTimeout(window.minOrderTimer);
    window.minOrderTimer = setTimeout(checkCart, CHECK_INTERVAL);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Extra triggers for AJAX cart
  document.addEventListener("cart:updated", checkCart);
  document.addEventListener("change", checkCart);
  document.addEventListener("click", (e) => {
    if (e.target.matches(".cart__quantity-input, .quantity__button"))
      setTimeout(checkCart, 150);
  });

  // Initial check
  checkCart();
});
